
export default function ordersToEndpoint(orders) {
    return orders.filter(({key}) => key !== null).map(({key, isAsc}) => [key, isAsc]);
}
